// extracted by mini-css-extract-plugin
module.exports = {"container":"confirm-modal_container__3G3N9","title":"confirm-modal_title__23Edu","content":"confirm-modal_content__2dvkW"};